import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { HttpParamsBuilder, RestClientList } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { Column, Row } from '../../common/tables/table'
import { ProductionListFilterBuilder } from './production-list-filter-builder'

@Injectable({
  providedIn: 'root',
})
export class ProductionListService extends RestClientList<Row, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const httpClient = inject(HttpClient)
    super(environment.apiPath + '/production-list-data', httpClient)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getColumns(prodListConfId: string): Observable<Column[]> {
    return this.http.get<Column[]>(this.restEndpoint + '/columns', {
      params: HttpParamsBuilder.start()
        .appendFilters(ProductionListFilterBuilder.start().prodListConfId(prodListConfId).build())
        .build(),
    })
  }
}
